import { defineComponent as _defineComponent } from 'vue'
import { computed, useContext } from '@nuxtjs/composition-api';
import Modal from '@/components/common/Modal/Modal.vue';
import BravadoSpinnerV2 from '~/components/common/BravadoSpinnerV2/BravadoSpinnerV2.vue';

type JobsEditModalProps = {
  name: string;
  title: string;
  contentOverflow?: string;
  actionName?: string;
  closeButtonName?: string;
  actionType?: string;
  closeSilently?: boolean;
  disableAction?: boolean;
  autoFocusable?: boolean;
  persistent?: boolean;
  customContent?: boolean;
  customWidth?: boolean;
  customCloseAction?: boolean;
  isLoading?: boolean;
};

type JobsEditModalEmits = {
  (event: 'before-open'): void;
  (event: 'before-close'): void;
  (event: 'save'): void;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'JobsEditModal',
  props: {
    name: null,
    title: null,
    contentOverflow: { default: 'auto' },
    actionName: { default: 'Save' },
    closeButtonName: { default: 'Cancel' },
    actionType: { default: 'base' },
    closeSilently: { type: Boolean, default: false },
    disableAction: { type: Boolean, default: false },
    autoFocusable: { type: Boolean, default: true },
    persistent: { type: Boolean, default: false },
    customContent: { type: Boolean, default: false },
    customWidth: { type: Boolean, default: false },
    customCloseAction: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false }
  },
  emits: ["before-open", "before-close", "save"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'before-open'): void;
  (event: 'before-close'): void;
  (event: 'save'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { name: string, title: string, contentOverflow: string, actionName: string, closeButtonName: string, actionType: string, closeSilently: boolean, disableAction: boolean, autoFocusable: boolean, persistent: boolean, customContent: boolean, customWidth: boolean, customCloseAction: boolean, isLoading: boolean };




const { $modal } = useContext();

const rootClass = computed(() => ({
  'jobs-edit-modal': true,
  'jobs-edit-modal--custom-width': props.customWidth,
}));
const actionClass = computed(() => ({
  'jobs-edit-modal__action': true,
  [`jobs-edit-modal__action--${props.actionType}`]: true,
  'jobs-edit-modal__action--disabled': props.disableAction,
}));
const contentClass = computed(() => ({
  'jobs-edit-modal__content': true,
  'jobs-edit-modal__content--custom': props.customContent,
}));

function beforeClose() {
  if (props.closeSilently || props.customCloseAction) {
    $modal.hide(props.name);
    return;
  }

  emit('before-close');
  $modal.hide(props.name);
}

function handleClose() {
  if (props.customCloseAction) {
    emit('before-close');
    return;
  }

  beforeClose();
}

function handleSave() {
  if (props.disableAction) return;

  emit('save');
}

return { __sfc: true,props, emit, $modal, rootClass, actionClass, contentClass, beforeClose, handleClose, handleSave, Modal, BravadoSpinnerV2 }
}

})